module.exports = __webpack_public_path__ + "img/default.4cbb0988.png";